import type { FeatureBlockContent, HeroContent } from '../types';
import {
  accountsConvert as accountsConvertEn,
  accountsHero as accountsHeroEn,
  accountsReceive as accountsReceiveEn,
  accountsTransfer as accountsTransferEn,
} from '../accounts';

/**
 * Arabic homepage copy (premium Egyptian Arabic), from the nsave Arabic
 * Localization Pack, source snapshot 31 July 2026.
 *
 * Images, icons, hrefs and row ids are spread from the English content so a
 * change to an asset or route only has to be made once. Only human-readable
 * strings are overridden here.
 */

export const accountsHero: HeroContent = {
  ...accountsHeroEn,
  title: 'حسابك العالمي بالدولار واليورو والإسترليني',
  cta: { ...accountsHeroEn.cta, label: 'نزّل التطبيق' },
  image: {
    ...accountsHeroEn.image,
    alt: 'أصحاب بيقضوا وقت مع بعض، وأرصدة nsave بعملات مختلفة',
  },
};

export const accountsReceive: FeatureBlockContent = {
  ...accountsReceiveEn,
  title: 'استقبال الأموال',
  image: { ...accountsReceiveEn.image, alt: 'عيلة بتستقبل فلوس على nsave' },
  rows: [
    {
      ...accountsReceiveEn.rows[0],
      title: 'تحويلات USD',
      description:
        'خُد بيانات ACH وWire باسمك، واستقبل مدفوعاتك بالدولار من جهة عملك أو عملائك أو منصات العمل الحر.',
    },
    {
      ...accountsReceiveEn.rows[1],
      title: 'تحويلات GBP',
      description:
        'استلم من الشركات والعملاء في المملكة المتحدة بسرعة وموثوقية، عن طريق Wire أو FPS.',
    },
    {
      ...accountsReceiveEn.rows[2],
      title: 'تحويلات EUR',
      description:
        'استقبل مدفوعات EUR على IBAN باسمك عبر SEPA، واستلم رواتبك وفواتيرك وتحويلاتك من أوروبا.',
    },
  ],
};

export const accountsTransfer: FeatureBlockContent = {
  ...accountsTransferEn,
  title: 'التحويلات',
  image: { ...accountsTransferEn.image, alt: 'اختيار الدولة اللي هتحوّل لها على nsave' },
  rows: [
    {
      ...accountsTransferEn.rows[0],
      title: 'حوّل فلوسك لبلدك',
      description:
        'ابعت فلوس لحسابات محلية بالجنيه المصري والروبية الباكستانية والتاكا البنجلاديشية والليرة السورية وغيرها، أو لمحافظ الموبايل.',
      link: { ...accountsTransferEn.rows[0].link!, label: 'احسب التحويل' },
    },
    {
      ...accountsTransferEn.rows[1],
      title: 'تحويلات بنكية',
      description: 'ابعت USD وEUR وGBP لأي حساب بنكي، في بلدك أو بره.',
    },
    {
      ...accountsTransferEn.rows[2],
      title: 'تحويل لمحفظة عملات مستقرة',
      description: 'حوّل رصيدك على الشبكة وابعته لأي محفظة مدعومة في أي وقت.',
    },
  ],
};

export const accountsConvert: FeatureBlockContent = {
  ...accountsConvertEn,
  title: 'تحويل العملات',
  image: { ...accountsConvertEn.image, alt: 'تحويل العملات جوه تطبيق nsave' },
  rows: [
    {
      ...accountsConvertEn.rows[0],
      title: 'حوّل بين حساباتك بالدولار والإسترليني واليورو',
      description: 'بدّل بين أرصدتك فورًا في الوقت اللي يناسبك.',
    },
    {
      ...accountsConvertEn.rows[1],
      title: 'تحويل على مدار الساعة',
      description: 'حوّل في أي وقت، بالليل أو بالنهار، حتى وقت إغلاق الأسواق.',
    },
    {
      ...accountsConvertEn.rows[2],
      title: 'أسعار كويسة ورسوم منخفضة',
      description: 'سعر الصرف الحقيقي برسوم واضحة من غير فروق مخفية.',
    },
  ],
};
